import { useComponentRegistry } from '@bem-react/di';
import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

function IndexPage() {
    const { MainLayout } = useComponentRegistry('app');

    return (
        <Fragment>
            <Helmet>
                <title>Сайт рекламы</title>
                <meta name="title" content="Сайт рекламы" />
            </Helmet>
            <MainLayout
                title="Реактовая страница"
                transparent={false}
                >
                <div style={{ height: 600 }}>...Content...</div>
            </MainLayout>
        </Fragment>
    );
}

export default IndexPage;
